import { render } from "./CreateCutRequest.vue?vue&type=template&id=3f05ceee"
import script from "./CreateCutRequest.vue?vue&type=script&lang=js"
export * from "./CreateCutRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__